import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import {LoaderService } from '../service/loader.service'
import { finalize } from 'rxjs/operators';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';

export const LoadingInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const loaderService = inject(LoaderService); // Use inject to get the service

  // Check if the request has a header to skip loading
  const skipLoading = req.headers.has('Skip-Loading');

  if (!skipLoading) {
    loaderService.show(); // Show loader only if not skipped
  }

  return next(req).pipe(
    finalize(() => {
      if (!skipLoading) {
        loaderService.hide(); // Hide loader only if it was shown
      }
    })
  );
};
